export default "__VITE_IMAGE_ASSET__e8aa6b78__";